import { useEffect } from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Layout from "@/components/layout/Layout";
import { Seo } from "@/components/Seo";

const CheckoutCancelled = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <Seo
        title="Betaling avbrutt – Håp Naturlab"
        description="Betalingen ble avbrutt. Handlekurven er beholdt."
        noIndex
      />
      <section className="mx-auto max-w-2xl px-6 py-20 text-center">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-red-100">
          <XCircle className="h-10 w-10 text-red-600" />
        </div>
        <h1 className="mt-6 text-3xl font-bold font-heading">Betalingen ble avbrutt</h1>
        <p className="mt-4 text-lg text-muted-foreground font-body">
          Ingen betaling er gjennomført og handlekurven din er tatt vare på. Du kan fortsette når du vil.
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link
            to="/nettbutikk"
            className="inline-flex rounded-full bg-primary px-8 py-3.5 text-sm font-semibold text-primary-foreground font-body shadow-lg transition-all hover:opacity-90"
          >
            Tilbake til butikken
          </Link>
          <Link
            to="/kontakt"
            className="inline-flex rounded-full border-2 border-primary px-8 py-3.5 text-sm font-semibold text-primary font-body transition-all hover:bg-primary hover:text-primary-foreground"
          >
            Kontakt oss
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default CheckoutCancelled;
